/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @returns {{passwordGenerator: (function(*=, *=, *=, *=): void)}}
 * @constructor
 */
const PasswordGenerator = () => {
    /**
     * Generates a secure password with a default length of 8 characters.
     * Ensures inclusion of at least one uppercase letter, one number,
     * one special character, and one lowercase letter.
     *
     * @param {number} length - The desired length of the password (default is 8).
     * @returns {string} - A randomly generated secure password.
     */
    const passwordGenerator = (length = 8) => {
        const lowercase = 'abcdefghijklmnopqrstuvwxyz';
        const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const special = '!@#$%^&*()_+.';
        const allChars = lowercase + uppercase + numbers + special;

        let password = '';
        // Ensure at least one character from each required category
        password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
        password += numbers.charAt(Math.floor(Math.random() * numbers.length));
        password += special.charAt(Math.floor(Math.random() * special.length));
        password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));

        // Fill the remaining characters of the password
        for (let i = 4; i < length; ++i) {
            password += allChars.charAt(Math.floor(Math.random() * allChars.length));
        }

        // Shuffle the result to prevent predictable character positions
        return password
            .split('')
            .sort(() => 0.5 - Math.random())
            .join('');
    };

    // Return the password generator function
    return {
        passwordGenerator
    }
}

export default PasswordGenerator;
